import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
    hero_kicker: "Nick Moore — Prints & Original Works",
    hero_headline: "Portraits",
    hero_subline: "Celebrating the beauty, strength, and intimacy of the male form.",
    hero_description: "A curated collection of male portraits in charcoal, coloured pencil, and acrylic paint. Every print pulled from the artist's own archive.",
    about_title_line1: "A queer lens,",
    about_title_line2: "a classical look.",
    about_paragraph_1: "",
    about_paragraph_2: "",
    contact_email: "art.nickmoore@gmail.com",
    contact_phone: "0428 781 168",
    instagram_personal: "Nick_Moore",
    instagram_studio: "art_nmoore",
    hidden_pages: ["originals"],
};

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(DEFAULTS);

    const refresh = async () => {
        try {
            const r = await api.get("/settings");
            setSettings({ ...DEFAULTS, ...r.data });
        } catch (e) { /* keep defaults */ }
    };

    useEffect(() => { refresh(); }, []);

    return (
        <SettingsContext.Provider value={{ settings, refresh, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
}

export const useSettings = () => useContext(SettingsContext) || { settings: DEFAULTS };
